import { useNitroStore } from "../../store/Store";
import ProductPillFilter from "../../pages/home/components/filters/components/productPillFilter";

const HeaderProductFilter = ({
  value,
  disabled,
  setValue,
}: {
  value: string;
  disabled?: boolean;
  setValue: (value: string) => void;
}) => {
  const [priorityProducts] = useNitroStore((state) => [state.priorityProducts]);
  return (
    <ProductPillFilter
      products={priorityProducts}
      selectedProduct={value}
      disabled={disabled}
      setSelectedProduct={setValue}
    />
  );
};

export default HeaderProductFilter;
